var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8191_9320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4825 16.0379L41.3197 15.2282L34.4339 14.0253L38.4351 8.61193L37.9699 8.10305L32.0846 10.9253L32.8288 3.43006L32.224 3.08331L28.6415 9.14401L24.6174 0.12207H23.9195L24.8733 8.84342L14.7542 0.746698L13.8934 1.00114L21.6861 10.7867L6.26335 5.65093L5.56547 6.43745L19.3368 14.28L0.331338 15.8525L0.12207 17.0327L19.8718 19.184L3.40198 32.8095L4.09986 33.758L23.71 23.0936L19.8254 41.8779H21.0119L28.5255 24.2039L33.1082 38.0378L33.9226 37.4132L32.0382 23.3481L39.1796 31.4448L39.6451 30.7044L34.1782 20.6645L41.8083 23.4868L41.8781 22.6309L35.039 17.5877L41.4828 16.0379H41.4825Z",
    fill: "#FED42B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8191_9320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYm);
export default __webpack_public_path__ + "static/media/ym.7731ddf50d356e39f72f3b6743f06579.svg";
export { ForwardRef as ReactComponent };